import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import SimpleGoBoard from '../components/SimpleGoBoard';

export default function GameDetail() {
  const { id } = useParams();
  const [game, setGame] = useState(null);
  const [sgfContent, setSgfContent] = useState('');
  const [sgfError, setSgfError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGame();
    fetchSGF();
  }, [id]);

  const fetchGame = async () => {
    try {
      const res = await axios.get(`/api/games/${id}`);
      setGame(res.data.game);
    } catch (error) {
      console.error('获取棋谱详情失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSGF = async () => {
    try {
      // 尝试获取SGF（未登录也可下载，受每日配额限制）
      const savedUser = localStorage.getItem('user');
      const headers = {};
      if (savedUser) {
        const userData = JSON.parse(savedUser);
        if (userData?.token) {
          headers.Authorization = `Bearer ${userData.token}`;
        }
      }
      const res = await axios.get(`/api/games/${id}/sgf`, { headers });
      setSgfContent(res.data);
      setSgfError('');
    } catch (error) {
      if (error.response?.status === 429) {
        // 每日配额超限
        const data = error.response.data;
        if (data?.code === 'DAILY_QUOTA_EXCEEDED') {
          const quota = data.quota;
          setSgfError(data.error || `今日下载已达上限（${quota?.limit}个/天）`);
        } else {
          setSgfError('请求过于频繁，请稍后再试');
        }
      } else if (error.response?.status === 401) {
        setSgfError('请先登录后下载完整棋谱，未登录用户可在线查看完整棋谱');
      } else {
        console.error('获取SGF文件失败:', error);
        setSgfError('加载棋谱失败，请稍后重试');
      }
    }
  };

  const savedUser = localStorage.getItem('user');
  const downloadSGF = savedUser ? () => {
    if (!sgfContent) return;
    const blob = new Blob([sgfContent], { type: 'application/x-go-sgf' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = game?.filename || 'game.sgf';
    a.click();
    URL.revokeObjectURL(url);
  } : undefined;

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-8 text-center">
        <div className="text-gray-500">加载中...</div>
      </div>
    );
  }

  if (!game) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-8 text-center">
        <p className="text-gray-500">棋谱不存在</p>
        <Link to="/" className="text-go-black hover:underline mt-4 inline-block">
          返回首页
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-1">
      {/* 棋谱信息 */}
      <div className="bg-white rounded-lg shadow p-2 mb-2">
        <div className="flex justify-between items-center gap-4">
          <div className="text-xs sm:text-sm md:text-lg font-bold text-gray-800">
            {game.tournament}
          </div>
          <div className="text-xs sm:text-sm md:text-lg font-bold bg-yellow-100 text-yellow-800 px-2 py-0 rounded-lg">
            {game.result}
          </div>
          <div className="text-xs sm:text-sm md:text-lg font-bold text-black">
            {game.play_date}
          </div>
        </div>
      </div>

      {/* SGF查看器 */}
      <div className="bg-white rounded-lg shadow px-2 md:px-4 lg:px-6 pt-0 pb-0 h-[calc(100vh-115px)] sm:h-[calc(100vh-125px)] lg:h-[calc(100vh-130px)] flex flex-col">
        {/* 集成棋谱查看器 */}
        {sgfContent ? (
          <SimpleGoBoard sgfContent={sgfContent} gameInfo={game} downloadSGF={downloadSGF} />
        ) : sgfError ? (
          <div className="bg-amber-50 rounded-lg p-8 min-h-[400px] flex items-center justify-center">
            <div className="text-center">
              <p className="text-gray-700 mb-3">{sgfError}</p>
              <Link to="/login" className="inline-block bg-go-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 text-sm">
                去登录
              </Link>
            </div>
          </div>
        ) : (
          <div className="bg-amber-100 rounded-lg p-8 min-h-[400px] flex items-center justify-center">
            <p className="text-gray-700 text-center">
              正在加载棋谱...
            </p>
          </div>
        )}

      </div>
    </div>
  );
}
